import { NameDto } from 'api/Common/Types'

export enum TransactionValidationState {
  Succeeded = 30,
  Failed = 20,
}

export interface TransactionValidationsDto {
  created: Date
  id: string
  log: {
    html: (string | { tag: string })[]
    text: string
  }
  name: string
  paymentOption: NameDto<number>
  state: NameDto<TransactionValidationState>
  updated: Date
}
